// Get wines
export const FETCHWINES = "FETCHWINES"
export const FETCH_ERROR = "FETCH_ERROR"
export const IMAGES_URL = "IMAGES_URL"

// filter wines
export const FILTER_WINES = "FILTER_WINES"
export const FILTER_ERROR = "FILTER_ERROR"
export const ORDERS = "ORDERS"
export const ORDERITEMS ="ORDERITEMS"

// view single product
export const VIEW_DETAILS = "VIEW_DETAILS"

// add to cart
export const ADDTOCART = "ADDTOCART"
export const EMPTY_CART ="EMPTY_CART"
export const CARTITEMS = "CARTITEMS"

// calculate the totals
export const CALCULATEAllTOTALS = "CALCULATEAllTOTALS"

// checkout
export const CHECKOUTREQUIREMENTS = "CHECKOUTREQUIREMENTS"

// auto calculation on quantity increase or decrease on single product
export const SINGLE_WINE_CALCULATION = "SINGLE_WINE_AUTOCALCULATION"